import React, { Component } from "react";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { Link } from "react-router-dom";

import { Container, Row, Col, CardBody, Card, Button, Label } from "reactstrap";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logo.svg";
import avatar from "../../assets/images/users/avatar-1.jpg";
import logowhite from "../../assets/images/brands/AES-logo1-white.svg";
import flamingologo from "../../assets/images/brands/flamingo.svg";
import appuser1 from "../../assets/images/brands/app-user1.jpg";

class LockScreen extends Component {
  render() {
    //meta title
    document.title = "Lock Screen | Skote - React Admin & Dashboard Template";
    return (
      <React.Fragment>
        {/* <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="mdi mdi-home-outline text-white" style={{"fontSize": "20px", "border":"1px solid #fff","padding":"8px 10px","borderRadius":"50%"}} />
          </Link>
        </div> */}
        <div className="account-pages my-0 d-flex flex-wrap align-items-center login-form-bg">
          <Container>
            <Row className="justify-content-center">
              <Col md="8" lg="6" xl="5" className="px-3">
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col xs="7" className="w-100" style={{
                        background: "linear-gradient(90deg, #001f3f, #003f7f)",
                      }}>
                        <div className="lockscreen-logos d-flex align-items-center justify-content-between w-100 pe-4 px-4 pt-4 ">
                          <img src={logowhite} alt="Logo" className="mb-0" />
                          <img src={flamingologo} alt="Flamingo Logo" className="mb-0" />
                        </div>
                        <div className="text-white text-center p-4 w-100">
                          <h5 className="text-white" style={{fontSize: "25px",lineHeight: "30px", fontWeight: "600"}}>Lock screen</h5>
                          <p className="mb-0">Enter your password to unlock the screen!</p>
                        </div>
                      </Col>
                      {/* <Col xs="5" className="align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col> */}
                    </Row>
                  </div>
                  <CardBody className="p-4">
                    {/* <div>
                      <Link to="/">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logoImg}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div> */}
                    <div className="p-0">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          password:
                            (this.state && this.state.password) || "",
                        }}
                        validationSchema={Yup.object().shape({
                          password: Yup.string().required(
                            "Please Enter Valid Password"
                          ),
                        })}
                        onSubmit={values => {
                          console.log(values, "values");
                        }}
                      >
                        {({ errors, status, touched }) => (
                          <Form className="form-horizontal">
                            <div className="user-thumb text-center mb-4">
                              <img
                                src={appuser1}
                                className="rounded-circle img-thumbnail avatar-md"
                                alt="thumbnail"
                              />
                              <h5 className="font-size-15 mt-1 text-black">John</h5>
                            </div>

                            <div className="mb-3">
                              <Label for="password" className="form-label" style={{fontSize: "15px", color: "#000", fontWeight: "500"}}>
                                Password
                              </Label>
                              <Field
                                name="password"
                                placeholder="Enter Password"
                                type="password"
                                className={
                                  "form-control" +
                                  (errors.password && touched.password
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="password"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>

                            <div className="text-end">
                              <Col xs="12" className="text-end">
                                <Button
                                  color="primary"
                                  className=" w-md"
                                  type="submit"
                                >
                                  Unlock
                                </Button>
                              </Col>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-3 text-center">
                  <p className="text-white">
                    Not you ? return{" "}
                    <Link to="/login" className="fw-medium text-danger">
                      {" "}
                      Sign In{" "}
                    </Link>{" "}
                  </p>
                  <p className="text-white">
                    © 2025 Copyright © AES Technologies | All Rights Reserved.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default LockScreen;
